// React Imports
import { useEffect, useState } from 'react'

// MUI Imports
import { useColorScheme } from '@mui/material/styles'

// Type Imports
import type { SystemMode } from '@/core/types/types'

// Hook Imports
import { useSettings } from '@/core/hooks/useSettings'

const ModeChanger = ({ systemMode }: { systemMode: SystemMode }) => {
  // Hooks
  const { setMode } = useColorScheme()
  const { settings } = useSettings()
  const [mounted, setMounted] = useState(false)
  const [isDark, setIsDark] = useState(systemMode === 'dark')

  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    if (!mounted) return

    // Check user's color scheme preference after component mounts
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

    setIsDark(mediaQuery.matches)

    const handleChange = (e: MediaQueryListEvent) => {
      setIsDark(e.matches)
    }

    mediaQuery.addEventListener('change', handleChange)

    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [mounted])

  useEffect(() => {
    if (!mounted) return

    if (settings.mode) {
      if (settings.mode === 'system') {
        setMode(isDark ? 'dark' : 'light')
      } else {
        setMode(settings.mode)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings.mode, isDark, mounted])

  return null
}

export default ModeChanger
